import { Command, CommandHandler, HttpService, TaggedUrl, Tags } from '@skylab-shared/core';
import { fillPlaceholders } from '@skylab-shared/utils';

export interface AdjustmentReasonSetDefaultParams {
    readonly id: number;
}

export type AdjustmentReasonSetDefaultResponse = {
    value: number,
    version: string
}[];

export class AdjustmentReasonSetDefaultCommand extends Command<AdjustmentReasonSetDefaultParams, AdjustmentReasonSetDefaultResponse> { }

export class AdjustmentReasonSetDefaultCommandHandlerBase implements CommandHandler<AdjustmentReasonSetDefaultCommand, AdjustmentReasonSetDefaultParams, AdjustmentReasonSetDefaultResponse> {
    private static Url = TaggedUrl.join('sales/adjustmentReasons/default/:id', [Tags.Api]);

    public constructor(
        private readonly http: HttpService
    ) {}

    public async handleAsync(command: AdjustmentReasonSetDefaultCommand): Promise<AdjustmentReasonSetDefaultResponse> {
        const { data } = await this.http.put(fillPlaceholders(AdjustmentReasonSetDefaultCommandHandlerBase.Url, { id: command.params?.id }));

        return data;
    }
}
